import {BranchPickerSharedSearchBranchesServerQuery} from '@github-ui/server-persisted-queries'
import type {BranchPickerSharedSearchBranchesServerQueryQuery} from '@github-ui/server-persisted-queries/types/BranchPickerSharedSearchBranchesServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export function branchPickerSearchQueryKey(owner: string, repo: string, searchQuery: string) {
  return ['item-picker-branch', 'search', {owner, repo, searchQuery}] as const
}

export async function fetchBranchPickerSearch(
  owner: string,
  repo: string,
  searchQuery: string,
  signal?: AbortSignal,
): Promise<BranchPickerSharedSearchBranchesServerQueryQuery> {
  const params = new URLSearchParams({
    queryId: BranchPickerSharedSearchBranchesServerQuery,
    query: searchQuery,
  })
  const response = await reactFetchJSON(`/${owner}/${repo}/branch_picker_search_branches.json?${params.toString()}`, {
    signal,
  })

  if (!response.ok) throw new Error(`Branch search failed (${response.status})`)

  const json = (await response.json()) as {
    data?: BranchPickerSharedSearchBranchesServerQueryQuery
    errors?: unknown[]
  }
  if (json.errors?.length || !json.data) throw new Error('Branch search query returned errors')

  return json.data
}
